import { render, staticRenderFns } from "./CustomBtn.vue?vue&type=template&id=73500817&scoped=true&"
import script from "./CustomBtn.vue?vue&type=script&lang=js&"
export * from "./CustomBtn.vue?vue&type=script&lang=js&"
import style0 from "./CustomBtn.vue?vue&type=style&index=0&id=73500817&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73500817",
  null
  
)

export default component.exports